import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Lock } from 'lucide-react';
interface AdminLoginProps {
  onLogin: () => void;
}
export function AdminLogin({
  onLogin
}: AdminLoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'ptc2026admin') {
      onLogin();
    } else {
      setError('Incorrect password');
    }
  };
  return <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded-xl shadow-lg border border-gray-200" data-id="element-10">
      <div className="text-center mb-8" data-id="element-11">
        <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-12">
          <Lock className="w-6 h-6 text-blue-600" data-id="element-13" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-14">Admin Access</h1>
        <p className="text-gray-600 mt-2" data-id="element-15">
          Please enter the password to continue
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-16">
        <Input type="password" placeholder="Enter password" value={password} onChange={e => {
        setPassword(e.target.value);
        setError('');
      }} error={error} data-id="element-17" />
        <Button type="submit" className="w-full" data-id="element-18">
          Login
        </Button>
      </form>
    </div>;
}